import createCrudModule from '@modules/crud/createCrudModule';

import TimesheetModel from './timesheet.model.js'

export { TimesheetModel }

export default createCrudModule('timesheet', TimesheetModel.getDefaults());

export const getEmptyTimesheetLine = (key) => ({
	key,
	monday: { start: '09:00', end: '17:00' },
	tuesday: { start: '09:00', end: '17:00' },
	wednesday: { start: '09:00', end: '17:00' },
	thursday: { start: '09:00', end: '17:00' },
	friday: { start: '09:00', end: '17:00' },
	saturday: { start: '', end: '' },
	sunday: { start: '', end: '' },
})



// WEBPACK FOOTER //
// ./src/modules/timesheet/timesheet.module.js